export const TERMS_URL =
  'https://docs.google.com/document/d/e/2PACX-1vTGYGGnEoQSq1lkRQzfubVRotEiEJMUhPUAVy10O2AUWTnDmMeXWHVcr9DOoMmzvQ/pub?embedded=true';

export const ABOUT_US_URL =
  'https://docs.google.com/document/d/e/2PACX-1vS2vpM4rGQ0FSJjRBRyFIa6Siw4t5tmtED3hMA_QL_lN7ek_Y7cEIAED15lsGpB24N19WY6Olm-35H1/pub?embedded=true';

export const PRIVACY_POLICY_URL =
  'https://docs.google.com/document/d/e/2PACX-1vQzAwvpEvZl9Dj5XtVVe2JH4utvziN4P0k2TLrsAsOuXRbAFo44Y5YVAeZreZ9VNg/pub?embedded=true';
